import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useCustomServiceContext } from 'contexts/useCustomServiceContext';
import CustomServiceLayout from 'layouts/CustomServiceLayout';
import SpecificationsForm from 'components/CustomService/SpecificationsForm';

export default function SpecificationsPage() {
  const router = useRouter();
  const [customService] = useCustomServiceContext();

  useEffect(() => {
    if (customService.quantity === 0) {
      router.push('/custom-services');
    }

    if (customService.id) {
      router.push('/custom-services/thanks');
    }
  }, [customService]);

  return (
    <CustomServiceLayout>
      <SpecificationsForm />
    </CustomServiceLayout>
  );
}
